import React from 'react';
import PropTypes from 'prop-types';
import { Conditional } from '../../../utils/consts';
import { TourCard, Spinner } from '../../../component';

const ToursGrid = ({
  buttonLabelId = 'profile.viewdetails',
  data = [],
  intl = {},
  language = { name: 'en', direction: 'ltr' },
  onClick = () => {},
  isLoading = true,
}) => {
  return (
    <section className="w-100 h-min-tour-grid px-3">
      <Conditional checkRender={!isLoading && !!data?.length}>
        <>
          {data.map((tour) => (
            <TourCard
              buttonLabelId={buttonLabelId}
              key={tour?._id}
              intl={intl}
              language={language}
              data={tour}
              onSelect={(data) => onClick(data)}
            />
          ))}
        </>
      </Conditional>
      <Conditional checkRender={isLoading}>
        <Spinner />
      </Conditional>
      <Conditional checkRender={!isLoading && !data?.length}>
        <div className="w-100 text-center font-large">
          {intl.formatMessage({ id: 'profile.notfound' })}
        </div>
      </Conditional>
    </section>
  );
};

ToursGrid.propTypes = {
  buttonLabelId: PropTypes?.string,
  data: PropTypes?.array,
  intl: PropTypes?.object,
  language: PropTypes?.object,
  onClick: PropTypes?.func,
  isLoading: PropTypes?.bool,
};

export default ToursGrid;
